module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjEiIGN5PSIyMSIgcj0iMTYiIGZpbGw9IiMxRDMzNTQiLz4KPGNpcmNsZSBjeD0iMjEiIGN5PSIyMSIgcj0iMTguNSIgc3Ryb2tlPSIjMUQzMzU0IiBzdHJva2Utb3BhY2l0eT0iMC4xIiBzdHJva2Utd2lkdGg9IjUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/notification-icon.svg
// module id = 5hPE
// module chunks = 0